import { useState } from 'react';
import { motion } from 'framer-motion';
import { Plus, Save, X } from 'lucide-react';
import { feedService } from '../services/feedService';
import { Feed } from './Feed';

interface FeedPost {
  id?: number;
  title: string;
  content: string;
  imageUrl?: string;
  author: string;
}

export function AdminFeed() {
  const [posts, setPosts] = useState<FeedPost[]>([]);
  const [isEditing, setIsEditing] = useState(false);
  const [currentPost, setCurrentPost] = useState<FeedPost>({
    title: '',
    content: '',
    imageUrl: '',
    author: ''
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const adminKey = 'lyfy-admin-key-2024';
    
    if (currentPost.id) {
      await feedService.updatePost(currentPost, adminKey);
    } else {
      await feedService.createPost(currentPost, adminKey);
    }
    
    setIsEditing(false);
    setCurrentPost({
      title: '',
      content: '',
      imageUrl: '',
      author: ''
    });
  };

  return (
    <div className="max-w-4xl mx-auto p-6">
      <button
        onClick={() => setIsEditing(true)}
        className="mb-6 flex items-center space-x-2 bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700"
      >
        <Plus className="w-5 h-5" />
        <span>New Post</span>
      </button>

      {isEditing && (
        <motion.form
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-lg shadow-lg p-6 mb-6"
          onSubmit={handleSubmit}
        >
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Title</label>
              <input
                type="text"
                value={currentPost.title}
                onChange={(e) => setCurrentPost({ ...currentPost, title: e.target.value })}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Content</label>
              <textarea
                value={currentPost.content}
                onChange={(e) => setCurrentPost({ ...currentPost, content: e.target.value })}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500"
                rows={6}
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Image URL</label>
              <input
                type="url"
                value={currentPost.imageUrl}
                onChange={(e) => setCurrentPost({ ...currentPost, imageUrl: e.target.value })}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Author</label>
              <input
                type="text"
                value={currentPost.author}
                onChange={(e) => setCurrentPost({ ...currentPost, author: e.target.value })}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500"
                required
              />
            </div>
          </div>

          <div className="mt-6 flex justify-end space-x-3">
            <button
              type="button"
              onClick={() => setIsEditing(false)}
              className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50"
            >
              <X className="w-4 h-4 mr-2" />
              Cancel
            </button>
            <button
              type="submit"
              className="inline-flex items-center px-4 py-2 border border-transparent rounded-md text-white bg-purple-600 hover:bg-purple-700"
            >
              <Save className="w-4 h-4 mr-2" />
              Save
            </button>
          </div>
        </motion.form>
      )}

      <Feed />
    </div>
  );
} 